import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { financeApi, Payable } from '../../api/finance';
import { SectionHeader } from '../../components/SectionHeader';
import { PageHeader } from '../../components/PageHeader';
import { StatusBadge } from '../../components/StatusBadge';
import { IconActionButton } from '../../components/IconActionButton';
import { Eye } from 'lucide-react';
import { DataTable } from '../../components/DataTable';

const STATUS_LABELS: Record<string, string> = { outstanding: 'Outstanding', partially_paid: 'Partially Paid', paid: 'Paid' };

export function PayablesPage() {
  const navigate = useNavigate();
  const payablesQuery = useQuery({ queryKey: ['finance-payables'], queryFn: () => financeApi.listPayables() });

  return (
    <div className="page">
      <PageHeader title="Accounts Payable" description="Amounts owed to staff for approved expense claims. Vendor/supplier payables will appear here once Procurement exists." />

      <div className="panel">
        <SectionHeader title="All Payables" />
        <div className="panel-body">
        {payablesQuery.data && (
          <DataTable<Payable>
            rows={payablesQuery.data.data}
            rowKey={(p) => p.id}
            emptyMessage="No payables yet."
            columns={[
              { header: 'Reference', render: (p) => p.payable_reference },
              { header: 'Payee', render: (p) => p.payee_name ?? '-' },
              { header: 'Source', render: (p) => p.source_module },
              { header: 'Amount', render: (p) => Number(p.amount).toLocaleString() },
              { header: 'Paid', render: (p) => Number(p.amount_paid).toLocaleString() },
              { header: 'Outstanding', render: (p) => (Number(p.amount) - Number(p.amount_paid)).toLocaleString() },
              { header: 'Status', render: (p) => <StatusBadge status={p.status} label={STATUS_LABELS[p.status]} /> },
              { header: '', render: (p) => <IconActionButton icon={Eye} label="View" onClick={() => navigate(`/finance/payables/${p.id}`)} /> },
            ]}
          />
        )}
      </div>
      </div>
    </div>
  );
}
